import { render, staticRenderFns } from "./BankSelect.vue?vue&type=template&id=980ef68e&scoped=true&"
import script from "./BankSelect.vue?vue&type=script&lang=js&"
export * from "./BankSelect.vue?vue&type=script&lang=js&"
import style0 from "./BankSelect.vue?vue&type=style&index=0&id=980ef68e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980ef68e",
  null
  
)

export default component.exports